import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const LINKED_SITES_HELP: HelpContent[] = [
    {
        helpContentId: 'linked-sites.master-site',
        tooltipText: 'Master site'
    }
];
